/**
 * @generated SignedSource<<5d2bbc80e1c6738ea6a17dcaad56e8d9>>
 * @relayHash d1c5670c44e9f8fc9ac768758d436087
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8e8353d3ad0b3fc7ac6fe01393daf5d0934740f4bc4ac7fb665f4815b9daf79c

import type { ConcreteRequest } from 'relay-runtime';
export type useContentTypesTitleUpdateContentTitleMutation$variables = {
  contentId: string;
  title?: string | null;
};
export type useContentTypesTitleUpdateContentTitleMutation$data = {
  readonly updateTitle: {
    readonly id: string | null;
    readonly links: {
      readonly editui: string | null;
      readonly webui: string | null;
    } | null;
    readonly title: string | null;
  } | null;
};
export type useContentTypesTitleUpdateContentTitleMutation = {
  response: useContentTypesTitleUpdateContentTitleMutation$data;
  variables: useContentTypesTitleUpdateContentTitleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "title"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "updateTitle",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "editui"
          },
          {
            "kind": "ScalarField",
            "name": "webui"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentTypesTitleUpdateContentTitleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentTypesTitleUpdateContentTitleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d1c5670c44e9f8fc9ac768758d436087",
    "id": "8e8353d3ad0b3fc7ac6fe01393daf5d0934740f4bc4ac7fb665f4815b9daf79c",
    "metadata": {},
    "name": "useContentTypesTitleUpdateContentTitleMutation",
    "operationKind": "mutation",
    "text": "mutation useContentTypesTitleUpdateContentTitleMutation($contentId:ID!,$title:String){updateTitle(contentId:$contentId,title:$title){id,title,links{editui,webui}}}"
  }
};
})();

(node as any).hash = "8c498978fbdcfa01faf33b30473c33ec";

export default node;
